import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';
import { IconX } from '@wds/icons';

import useStyles from './useStyles';

const CloseButton = ({
  children,
  component,
  label,
  onClick,
  type,
  variant,
  ...rest
}) => {
  const theme = useTheme();
  const { wrenchCloseButton } = useStyles({ theme, component });

  return (
    <button
      onClick={onClick}
      type="button"
      className={wrenchCloseButton}
      aria-label={label}
      {...safeRest(rest)}
    >
      <IconX title="close" color={variant} />
    </button>
  );
};

CloseButton.propTypes = {
  children: PropTypes.string,
  component: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light']),
};

CloseButton.defaultProps = {
  children: 'CloseButton',
  component: undefined,
  type: undefined,
  variant: 'light',
};

export default CloseButton;
